import formInputsTypes from '../simulatorConstant';
const forfaitsData = [
	{
		id: 1,
		label: "Forfait Déblocage d'un volet roulant (facile)",
		value: "Déblocage d'un volet roulant facile",
		description:
			"* Forfait Déblocage d'un volet roulant :\n" +
			'- Déblocage du volet manuellement\n' +
			'- Réajustement et remise en fonctionnement du mécanisme / des lames\n' +
			'- Contrôle complet du volet après intervention.',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 1,
		label: "Forfait Déblocage d'un volet roulant (difficile)",
		value: "Déblocage d'un volet roulant difficile",
		description:
			"* Forfait Déblocage d'un volet roulant :\n" +
			'- Déblocage du volet manuellement\n' +
			'- Réajustement et remise en fonctionnement du mécanisme / des lames\n' +
			'- Contrôle complet du volet après intervention.',
		lst_price: 280,
		isInline: true,
	},

	{
		id: 20,
		label: 'Forfait Changement de manivelle pour volet roulant manuel',
		value: 'Changement de manivelle pour volet roulant manuel',
		description:
			'* Forfait Changement de manivelle pour volet roulant : \n' +
			'Fourniture :\n' +
			'- Manivelle pour volet roulant manuel, compatible avec l’installation existante\n' +
			'- Accessoires de fixation (visserie, cache, embouts)\n\n' +
			'Main d’œuvre :\n' +
			'- Dépose de l’ancienne manivelle défectueuse\n' +
			'- Vérification du bon état du treuil et de la sortie de caisson\n' +
			'- Installation de la nouvelle manivelle\n' +
			'- Réglage de la longueur et de l’axe de manœuvre\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon enroulement du tablier\n',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 21,
		label: 'Fourniture et pose de mécanisme complet (manivelle + tige)',
		value: 'Fourniture et pose mécanisme complet volet roulant manuel',
		description:
			'* Fourniture et pose de mécanisme complet (manivelle + tige) : \n' +
			'Fourniture :\n' +
			'- Mécanisme complet de manœuvre pour volet roulant manuel (manivelle + tige)\n' +
			'- Accessoires de fixation nécessaires (visserie, caches, embouts)\n\n' +
			'Main d’œuvre :\n' +
			'- Dépose de l’ancien mécanisme de manœuvre existant\n' +
			'- Fourniture et remplacement des petites pièces de fixation si nécessaire\n' +
			'- Mise en place et réglage du nouveau mécanisme de manœuvre (manivelle et tige)\n' +
			'- Fixation de la manivelle et alignement de la tige\n' +
			'- Essais de fonctionnement montée / descente du volet roulant\n' +
			'- Nettoyage et remise en état du chantier après intervention\n',
		lst_price: 350,
		isInline: true,
	},
	{
		id: 20,
		label: 'Fourniture et pose de  mécanisme complet ( manivelle + tige )',
		value: 'Fourniture et pose de  mécanisme complet ( manivelle + tige )',
		description:
			'* Fourniture et pose de  mécanisme complet ( manivelle + tige ) : \n' +
			'Fourniture :\n' +
			'-  Fourniture des petites pièces de fixation si nécessaire\n' +
			'- Accessoires de fixation (visserie, cache, embouts)\n\n' +
			'Main d’œuvre :\n' +
			'- Dépose de l’ancien mécanisme de manœuvre existant défectueuse\n' +
			'- Vérification du bon état du treuil et de la sortie de caisson\n' +
			'- Installation de la nouvelle manivelle\n' +
			'- Réglage de la longueur et de l’axe de manœuvre\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon enroulement du tablier\n',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 20,
		label: "Forfait Changement des agrafes d'un volet roulant (Facile)",
		value: "Changement des agrafes d'un volet roulant Facile",
		description:
			"* Forfait Changement des agrafes d'un volet roulant : \n" +
			'Fourniture :\n' +
			'- Agrafes / attaches de tablier pour volet roulant, compatibles avec l’installation existante\n' +
			'- Éléments de fixation nécessaires (axes, clips, visserie selon configuration)\n\n' +
			'Main d’œuvre :\n' +
			'- Ouverture du coffre du volet roulant\n' +
			'- Dépose des agrafes / attaches défectueuses\n' +
			'- Vérification de l’état du tablier et de l’axe d’enroulement\n' +
			'- Installation des nouvelles agrafes de tablier\n' +
			'- Réglage et fixation du tablier sur l’axe\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon alignement et de l’enroulement du volet\n',
		lst_price: 170,
		isInline: true,
	},
	{
		id: 20,
		label: "Forfait Changement des agrafes d'un volet roulant (Difficile)",
		value: "Changement des agrafes d'un volet roulant Difficile",
		description:
			"* Forfait Changement des agrafes d'un volet roulant : \n" +
			'Fourniture :\n' +
			'- Agrafes / attaches de tablier pour volet roulant, compatibles avec l’installation existante\n' +
			'- Éléments de fixation nécessaires (axes, clips, visserie selon configuration)\n\n' +
			'Main d’œuvre :\n' +
			'- Ouverture du coffre du volet roulant\n' +
			'- Dépose des agrafes / attaches défectueuses\n' +
			'- Vérification de l’état du tablier et de l’axe d’enroulement\n' +
			'- Installation des nouvelles agrafes de tablier\n' +
			'- Réglage et fixation du tablier sur l’axe\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon alignement et de l’enroulement du volet\n',
		lst_price: 280,
		isInline: true,
	},

	{
		id: 4,
		label: 'Forfait Remplacement de télécommande',
		value: 'Remplacement de télécommande',
		description:
			'* Forfait Remplacement de télécommande : \n' +
			'Fourniture :\n' +
			'- Remplacement de la télécommande adapté a la motorisation existante \n' +
			'- Paramétrage des canaux et fonctions selon l’installation\n\n' +
			'Main d’œuvre :\n' +
			'- Diagnostic du système de motorisation et de la compatibilité de la télécommande\n' +
			'- Mise en mode apprentissage du moteur ou du récepteur\n' +
			'- Programmation et synchronisation de la télécommande\n' +
			'- Test des fonctions montée / descente / arrêt\n' +
			'- Vérification du bon fonctionnement et de la portée de la télécommande\n',

		lst_price: 220,
		isInline: true,
	},
	{
		id: 5,
		label: 'Forfait Réglage des fins de course',
		value: 'Réglage des fins de course',
		description:
			'* Forfait Réglage des fins de course :\n' +
			'- Réinitialisation et remise à zéro de la mémoire de la télécommande\n' +
			'- Réglage des positions haute et basse du volet roulant\n' +
			'- Validation de la programmation et verrouillage de la mémoire\n' +
			'- Tests complets : montée, descente et arrêt\n',
		lst_price: 220,
		isInline: true,
	},
];

const forfaitsVolet = {
	id: 'ForfaitsSM',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Forfaits',
	name: 'ForfaitsSM',
	className: 'col-12',
	classGroup: 'simulator-check',
	options: forfaitsData,
};

export default forfaitsVolet;
